/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { inflect } from "~/tools";
import { Item } from "./types";

export const getFirstOptionLabel = (
  selectedOptions: string[],
  options: Item[]
) => {
  return options.find((option) => option.value === selectedOptions[0])?.label;
};

export const getMultiSelectLabel = (
  selectedCount: number,
  name: string,
  pluralName?: string
) => {
  const formatter = inflect(name, pluralName);
  return `${selectedCount} ${formatter(selectedCount)} Selected`;
};
